@if (show) {
  <div class="loading-indicator">
    <mat-spinner [diameter]="70" class="mat-spinner-color"></mat-spinner>
  </div>
}
@if (navigationProgress) {
  <div class="loading-indicator">
    <mat-spinner [diameter]="70" class="mat-spinner-color"></mat-spinner>
  </div>
}